import { render, staticRenderFns } from "./editorImage.vue?vue&type=template&id=0acf2988&scoped=true"
import script from "./editorImage.vue?vue&type=script&lang=js"
export * from "./editorImage.vue?vue&type=script&lang=js"
import style0 from "./editorImage.vue?vue&type=style&index=0&id=0acf2988&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acf2988",
  null
  
)

export default component.exports